<template>
  <div>
    <two-integrations :integration1="integration1" :integration2="integration2" :loading="false" />
    <div class="tile my-4">
      <activity-log :userId="user.id" :integrationId="integrationId" :isAdmin="isAdmin || isPartner" />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import DashboardLayout from "@/Layouts/DashboardLayout";
import IntegrationLayout from "@/Layouts/IntegrationLayout";
import TwoIntegrations from "@/components/Dashboard/TwoIntegrations";
import ActivityLog from "@/components/Dashboard/ActivityLog";

export default {
  name: "IntegrationActivity",

  layout: [DashboardLayout, IntegrationLayout],

  components: {
    TwoIntegrations,
    ActivityLog,
  },

  props: {
    user: Object,
  },

  computed: {
    ...mapGetters('integrationDetails', ['integration1', 'integration2', 'isAdmin', 'isPartner']),

    integrationId() {
      return this.$route().params.integration;
    },
  },
}
</script>
